module.exports = __webpack_public_path__ + "static/media/toaster-ok.748c8349.svg";